import { isKnownDistrict, regionAfterOblastChange } from './districts';

// Населённые пункты по областям и районам (data/settlements.json, собирается скриптом
// scripts/build-settlements.py из классификатора КАТОТТГ). Файл большой (около полумегабайта),
// поэтому читается по требованию, когда открывается форма компании, и один раз за сеанс.
let cache = null;
export const loadSettlements = () => {
  if (!cache) {
    cache = import('./data/settlements.json').then((module) => module.default || module).catch(() => {
      cache = null; // не получилось: в следующий раз попробуем снова
      return {};
    });
  }
  return cache;
};

// Населённые пункты выбранного района выбранной области. Нет области, района или данных: пусто.
export const settlementsOf = (data, oblast, district) =>
  (data && data[oblast] && data[oblast][district]) || [];

// Область, район и населённый пункт связаны: после смены области или выбора другого района то,
// что к новому выбору не относится, сбрасывается. Сбрасывается только значение из справочника:
// то, что вписано вручную, остаётся (и пока район набирают руками, село не трогается).
// patch это то, что человек изменил ({ state } или { region }).
export const locationAfterChange = (previous, patch, data) => {
  const next = { ...previous, ...patch };
  if ('state' in patch) next.region = regionAfterOblastChange(previous.region, next.state);
  const wasListed = settlementsOf(data, previous.state, previous.region).includes(previous.city);
  const stillListed = settlementsOf(data, next.state, next.region).includes(previous.city);
  const choseAnother = 'state' in patch || isKnownDistrict(next.region);
  if (wasListed && !stillListed && choseAnother) next.city = '';
  return next;
};

// Для setState формы: меняет область, район и населённый пункт вместе.
export const locationUpdater = (patch) => (previous) => {
  const { state, region, city } = locationAfterChange(previous, patch, previous.settlements);
  return { state, region, city };
};
